import React, { useState, useEffect, useMemo } from 'react';
import Header from '../Component/Header';
import Footer from '../Component/Footer';
import Breadcrumb from '../Component/Breadcrumb';
import { getNewsInner } from "../Service/Api";

function News() {
  const [allNews, setAllNews] = useState([]);
  const [selectedYear, setSelectedYear] = useState("0");
  const [selectedMonth, setSelectedMonth] = useState("0");
  const [searchQuery, setSearchQuery] = useState("");
  const [availableYears, setAvailableYears] = useState([]);

  const monthNamesFull = Array.from({ length: 12 }, (_, i) =>
    new Date(0, i).toLocaleString('default', { month: 'long' })
  );

  useEffect(() => {
    async function fetchData() {
      const newsData = await getNewsInner();
      setAllNews(newsData);

      const years = Array.from(new Set(
        newsData.map(item => item.fromDate && new Date(item.fromDate).getFullYear()).filter(Boolean)
      )).sort((a, b) => b - a);
      setAvailableYears(years.map(y => y.toString()));

      const currentYearStr = new Date().getFullYear().toString();
      setSelectedYear(years.includes(+currentYearStr) ? currentYearStr : (years[0]?.toString() ?? "0"));
    }
    fetchData();
  }, []);

  const filteredNews = useMemo(() => {
    return allNews.filter(item => {
      if (!item.fromDate) return false;
      const date = new Date(item.fromDate);
      const itemYear = date.getFullYear().toString();
      const itemMonth = (date.getMonth() + 1).toString();

      const matchesYear = selectedYear === "0" || itemYear === selectedYear;
      const matchesMonth = selectedMonth === "0" || itemMonth === selectedMonth;
      const lowerSearch = searchQuery.toLowerCase();
      const matchesSearch = !searchQuery ||
        (item.title && item.title.toLowerCase().includes(lowerSearch)) ||
        (item.description && item.description.toLowerCase().includes(lowerSearch));

      return matchesYear && matchesMonth && matchesSearch;
    }).sort((a, b) => new Date(b.fromDate) - new Date(a.fromDate));
  }, [allNews, selectedYear, selectedMonth, searchQuery]);

  return (
    <>
      <Header />
      <Breadcrumb title="News" mainBreadcrumb="News" />
      <div className="inner-page ">
        <div className="container">
          <h2 className="mainhead">News</h2>

          <div className="row tabs-dynamic mb-4">
            <div className="col-md-3 col-sm-6 mb-2">
              <p><strong>Total Count:</strong> {filteredNews.length}</p>
            </div>
            <div className="col-md-3 col-sm-6 mb-2">
              <select value={selectedYear} onChange={e => setSelectedYear(e.target.value)} className="modern-select">
                <option value="0">Select Year</option>
                {availableYears.map(year => (
                  <option key={year} value={year}>{year}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3 col-sm-6 mb-2">
              <select value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} className="modern-select">
                <option value="0">All Months</option>
                {monthNamesFull.map((m, i) => (
                  <option key={i + 1} value={(i + 1).toString()}>{m}</option>
                ))}
              </select>
            </div>
            <div className="col-md-3 col-sm-6 mb-2">
              <input
                type="text"
                placeholder="Search here..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
                className="modern-input"
              />
            </div>
          </div>

          <div className="row">
            {filteredNews.length === 0 ? (
              <div className="col-12 text-center">
                <h4>No news found for selected filters.</h4>
              </div>
            ) : (
              filteredNews.map((item, idx) => {
                const date = new Date(item.fromDate);
                const day = date.getDate();
                const monthShort = date.toLocaleString('default', { month: 'short' });

                const attachmentUrl = item.attachments && item.attachments.length > 0
                  ? `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${item.attachments[0]}`
                  : null;

                return (
                  <div className="col-lg-6 mb-4" key={idx}>
                    <div className="news-card no-img">
                      <div className="news-content">
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                        <div className="news-footer">
                          <div className="news-date">{day} <span>{monthShort}</span></div>
                          {attachmentUrl && (
                            <a href={attachmentUrl} target="_blank" rel="noopener noreferrer" title="View Attachment">
                              <i className="bi bi-paperclip"></i>
                            </a>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default News;
